<template>
  <div class="page-content">
    <div class="tabs">
      <div :class="{'active': couponsTab == 2}" @click="switchTab(2)">未使用</div>
      <div :class="{'active': couponsTab == 1}" @click="switchTab(1)">已使用</div>
      <div :class="{'active': couponsTab == 3}" @click="switchTab(3)">已过期</div>
    </div>
    <div class="tab-content">
      <!-- 未使用 -->
      <div class="platform-lists">
        <template v-if="couponsDatas && couponsDatas.length">
          <div class="platform-list" v-for="(item,index) in couponsDatas" :key="index">
            <Coupons :width="'100%'" :height="'100px'" :coupons-data="item" :isClick="true"></Coupons>
          </div>
        </template>
        <empty v-else></empty>
      </div>

    </div>
  </div>
</template>

<script>
import Coupons from '@/components/Coupons'
import empty from '../Empty'

export default {
  name: 'MyVoucher',
  components: {Coupons, empty},
  data() {
    return {
      couponsDatas: [],
      //1=>已使用 2=>未使用 , 3=>已过期
      couponsTab: 2, //tab选项卡选中项
      couponPopupCType: 1, //优惠券类型 1驾校 2平台
      couponPopupGType: 1, //获取优惠券类型 1免费 2收费
    }
  },
  created() {
    this.get_lists();
  },
  methods: {
    get_lists() {
      this.$ajax.get('m/privilege/privilege_ajax_list', {
        activity_id: this.$ajax.get_activity_id(),
        type: this.couponsTab
      }).then(res => {
        this.couponsDatas = res;
      })
    },
    /*
     * 切换tab选项卡
     * @param {Number} index - 下标
     */
    switchTab(index) {
      this.couponsTab = index;
      this.couponsDatas = [];
      this.get_lists();

    },
  },
  mounted() {
    window.document.title = '我的卡券';
    setTimeout(() => {
      window.document.title = '我的卡券';
      setTimeout(() => {
        window.document.title = '我的卡券';
        setTimeout(() => {
          window.document.title = '我的卡券';
          setTimeout(() => {
            window.document.title = '我的卡券';
            setTimeout(() => {
              window.document.title = '我的卡券';
              setTimeout(() => {
                window.document.title = '我的卡券';
              }, 500);
            }, 500);
          }, 500);
        }, 500);
      }, 500);
    }, 500);
  }
}
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;

  .tabs {
    width: 100%;
    height: 40px;
    display: flex;

    div {
      width: 50%;
      height: 100%;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #666;
    }

    .active {
      font-weight: bold;
      color: #333;
      border-bottom: 2px #3C43EC solid;
    }
  }

  .tab-content {
    width: 100%;

    .platform-lists {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;

      .platform-list {
        width: 100%;
        height: 100px;
        margin-top: 10px;
      }
    }
  }
}
</style>
